import styled from "styled-components";

const OutlinedTitle = styled.h1`
    text-transform: uppercase;
    color: white;
    /* font-size: 5em; */
    position: relative;
    z-index: 2;

    font-family: var(--qanelas-main);

    width: fit-content;

    &::before {
        content: "${props => props.children}";
        content: "${props => props.children}" / "";
        position: absolute;
        top: 0;
        left: 0;
        -webkit-text-stroke: 0.1em var(--kpum-teal);
        text-shadow: 0 5px 10px rgb(0 0 0 / 0.6);
        /* text-shadow: 0 5px 10px rgb(0 0 0 / 0.5); Value from frontpage */
        z-index: -1;
    }
`;

export default OutlinedTitle;